import ClipboardPencil from './src/clipboard-pencil-combined';
export default ClipboardPencil;